// Render a deliberately small Markdown vocabulary as Vue text nodes. In particular,
// HTML, links and images cannot execute code or make external requests.
import { decode } from 'he'

function nodes(h, tokens) {
  return (tokens || []).map((token) => {
    const children = () =>
      token.tokens ? nodes(h, token.tokens) : [decode(token.text || '')]
    switch (token.type) {
      case 'heading':
        return h(`h${Math.min(4, Math.max(3, token.depth + 1))}`, children())
      case 'paragraph':
        return h('p', children())
      case 'strong':
        return h('strong', children())
      case 'em':
        return h('em', children())
      case 'del':
        return h('del', children())
      case 'codespan':
        return h('code', decode(token.text || ''))
      case 'code':
        return h('pre', [h('code', token.text)])
      case 'list':
        return h(
          token.ordered ? 'ol' : 'ul',
          token.items.map((item) => h('li', nodes(h, item.tokens)))
        )
      case 'blockquote':
        return h('blockquote', children())
      case 'table':
        return h(
          'div',
          {
            class: 'lynda-table-scroll',
            attrs: {
              tabindex: 0,
              role: 'region',
              'aria-label': 'Answer table',
            },
          },
          [
            h('table', [
              h('thead', [
                h(
                  'tr',
                  token.header.map((c) => h('th', nodes(h, c.tokens)))
                ),
              ]),
              h(
                'tbody',
                token.rows.map((row) =>
                  h(
                    'tr',
                    row.map((c) => h('td', nodes(h, c.tokens)))
                  )
                )
              ),
            ]),
          ]
        )
      case 'hr':
        return h('hr')
      case 'br':
        return h('br')
      case 'space':
        return ''
      case 'link':
        return h('span', children())
      case 'image':
        return decode(token.text || '')
      case 'text':
        return token.tokens ? h('span', children()) : decode(token.text || '')
      default:
        return token.text || ''
    }
  })
}
export default {
  name: 'AnswerMarkdown',
  functional: true,
  props: { token: Object },
  render(h, context) {
    return h(
      'div',
      { class: 'lynda-markdown' },
      nodes(h, [context.props.token])
    )
  },
}
